/**
 * WebGL detection utility
 * Checks if WebGL is supported in the current browser/environment
 */

export const isWebGLSupported = (): boolean => {
  try {
    const canvas = document.createElement('canvas');
    const gl =
      canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    return !!(gl && gl instanceof WebGLRenderingContext);
  } catch (error) {
    return false;
  }
};

export const isWebGL2Supported = (): boolean => {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl2');
    return !!(gl && gl instanceof WebGL2RenderingContext);
  } catch (error) {
    return false;
  }
};

export const getWebGLErrorInfo = (): string => {
  if (!isWebGLSupported()) {
    return 'WebGL is not supported in this browser or environment';
  }
  return 'WebGL is supported but failed to initialize';
};
